export const noDecimals = '1.0-0';
export const oneOrNoDecimals = '1.0-1';
export const oneDecimal = '1.1-1';

export const veryLargeNumber = 999999;
